export const HOME_LAYOUT_GRID = {
	xs: [
		{ i: 'block-top-filler-0', x: 0, y: -14, w: 1, h: 1, static: true },
		{ i: 'block-top-filler-1', x: 1.2, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-2', x: 3.6, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-3', x: 6, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-4', x: 8.4, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-5', x: 10.8, y: -14, w: 1, h: 1, static: true },

		{ i: 'block-top-0', x: 0, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-1', x: 2.4, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-2', x: 4.8, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-3', x: 7.2, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-4', x: 9.6, y: -7, w: 2, h: 1, static: true },

		{ i: 'block-second-0', x: 0, y: 1, w: 1, h: 8, static: true },
		{ i: 'block-second-1', x: 1.2, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-2', x: 3.6, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-3', x: 6, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-4', x: 8.4, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-5', x: 10.8, y: 1, w: 1, h: 8, static: true },

		{ i: 'block-third-0', x: 0, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-1', x: 2.4, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-2', x: 4.8, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-3', x: 7.2, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-4', x: 9.6, y: 9, w: 1.4, h: 8, static: true },

		{ i: 'block-fourth-0', x: 0, y: 17, w: 1, h: 8, static: true },
		{ i: 'block-fourth-1', x: 1.2, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-2', x: 3.6, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-3', x: 6, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-4', x: 8.4, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-5', x: 10.8, y: 17, w: 1.2, h: 8, static: true },

		{ i: 'block-fifth-0', x: 0, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-1', x: 2.4, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-2', x: 4.8, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-3', x: 7.2, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-4', x: 9.6, y: 25, w: 1.4, h: 8, static: true },

		{ i: 'block-sixth-0', x: 0, y: 33, w: 1.2, h: 8, static: true },
		{ i: 'block-sixth-1', x: 1.2, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-2', x: 3.6, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-3', x: 6, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-4', x: 8.4, y: 33, w: 2.3, h: 8, static: true },
		{ i: 'block-sixth-5', x: 10.9, y: 33, w: 1.3, h: 8, static: true },

		{ i: 'block-seventh-0', x: 0, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-1', x: 2.4, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-2', x: 4.8, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-3', x: 7.2, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-4', x: 9.6, y: 41, w: 1.4, h: 8, static: true },

		{ i: 'block-eighth-0', x: 0, y: 49, w: 1, h: 8, static: true },
		{ i: 'block-eighth-1', x: 1.2, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-2', x: 3.6, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-3', x: 6, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-4', x: 8.4, y: 49, w: 1.4, h: 8, static: true },
	],
	sm: [
		{ i: 'block-top-filler-0', x: 0, y: -14, w: 1, h: 1, static: true },
		{ i: 'block-top-filler-1', x: 1.2, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-2', x: 3.6, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-3', x: 6, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-4', x: 8.4, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-5', x: 10.8, y: -14, w: 1, h: 1, static: true },

		{ i: 'block-top-0', x: 0, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-1', x: 2.4, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-2', x: 4.8, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-3', x: 7.2, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-4', x: 9.6, y: -7, w: 2, h: 1, static: true },

		{ i: 'block-second-0', x: 0, y: 1, w: 1, h: 8, static: true },
		{ i: 'block-second-1', x: 1.2, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-2', x: 3.6, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-3', x: 6, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-4', x: 8.4, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-5', x: 10.8, y: 1, w: 1, h: 8, static: true },

		{ i: 'block-third-0', x: 0, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-1', x: 2.4, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-2', x: 4.8, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-3', x: 7.2, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-4', x: 9.6, y: 9, w: 1.4, h: 8, static: true },

		{ i: 'block-fourth-0', x: 0, y: 17, w: 1, h: 8, static: true },
		{ i: 'block-fourth-1', x: 1.2, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-2', x: 3.6, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-3', x: 6, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-4', x: 8.4, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-5', x: 10.8, y: 17, w: 1.2, h: 8, static: true },

		{ i: 'block-fifth-0', x: 0, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-1', x: 2.4, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-2', x: 4.8, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-3', x: 7.2, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-4', x: 9.6, y: 25, w: 1.4, h: 8, static: true },

		{ i: 'block-sixth-0', x: 0, y: 33, w: 1.2, h: 8, static: true },
		{ i: 'block-sixth-1', x: 1.2, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-2', x: 3.6, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-3', x: 6, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-4', x: 8.4, y: 33, w: 2.3, h: 8, static: true },
		{ i: 'block-sixth-5', x: 10.9, y: 33, w: 1.3, h: 8, static: true },

		{ i: 'block-seventh-0', x: 0, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-1', x: 2.4, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-2', x: 4.8, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-3', x: 7.2, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-4', x: 9.6, y: 41, w: 1.4, h: 8, static: true },

		{ i: 'block-eighth-0', x: 0, y: 49, w: 1, h: 8, static: true },
		{ i: 'block-eighth-1', x: 1.2, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-2', x: 3.6, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-3', x: 6, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-4', x: 8.4, y: 49, w: 1.4, h: 8, static: true },
	],
	md: [
		{ i: 'block-top-filler-0', x: 0, y: -14, w: 1, h: 1, static: true },
		{ i: 'block-top-filler-1', x: 1.2, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-2', x: 3.6, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-3', x: 6, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-4', x: 8.4, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-5', x: 10.8, y: -14, w: 1, h: 1, static: true },

		{ i: 'block-top-0', x: 0, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-1', x: 2.4, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-2', x: 4.8, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-3', x: 7.2, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-4', x: 9.6, y: -7, w: 2, h: 1, static: true },

		{ i: 'block-second-0', x: 0, y: 1, w: 1, h: 8, static: true },
		{ i: 'block-second-1', x: 1.2, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-2', x: 3.6, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-3', x: 6, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-4', x: 8.4, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-5', x: 10.8, y: 1, w: 1, h: 8, static: true },

		{ i: 'block-third-0', x: 0, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-1', x: 2.4, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-2', x: 4.8, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-3', x: 7.2, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-4', x: 9.6, y: 9, w: 1.4, h: 8, static: true },

		{ i: 'block-fourth-0', x: 0, y: 17, w: 1, h: 8, static: true },
		{ i: 'block-fourth-1', x: 1.2, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-2', x: 3.6, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-3', x: 6, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-4', x: 8.4, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-5', x: 10.8, y: 17, w: 1.2, h: 8, static: true },

		{ i: 'block-fifth-0', x: 0, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-1', x: 2.4, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-2', x: 4.8, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-3', x: 7.2, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-4', x: 9.6, y: 25, w: 1.4, h: 8, static: true },

		{ i: 'block-sixth-0', x: 0, y: 33, w: 1.2, h: 8, static: true },
		{ i: 'block-sixth-1', x: 1.2, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-2', x: 3.6, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-3', x: 6, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-4', x: 8.4, y: 33, w: 2.3, h: 8, static: true },
		{ i: 'block-sixth-5', x: 10.9, y: 33, w: 1.3, h: 8, static: true },

		{ i: 'block-seventh-0', x: 0, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-1', x: 2.4, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-2', x: 4.8, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-3', x: 7.2, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-4', x: 9.6, y: 41, w: 1.4, h: 8, static: true },

		{ i: 'block-eighth-0', x: 0, y: 49, w: 1, h: 8, static: true },
		{ i: 'block-eighth-1', x: 1.2, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-2', x: 3.6, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-3', x: 6, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-4', x: 8.4, y: 49, w: 1.4, h: 8, static: true },
	],
	lg: [
		{ i: 'block-top-filler-0', x: 0, y: -14, w: 1, h: 1, static: true },
		{ i: 'block-top-filler-1', x: 1.2, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-2', x: 3.6, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-3', x: 6, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-4', x: 8.4, y: -14, w: 2, h: 1, static: true },
		{ i: 'block-top-filler-5', x: 10.8, y: -14, w: 1, h: 1, static: true },

		{ i: 'block-top-0', x: 0, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-1', x: 2.4, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-2', x: 4.8, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-3', x: 7.2, y: -7, w: 2, h: 1, static: true },
		{ i: 'block-top-4', x: 9.6, y: -7, w: 2, h: 1, static: true },

		{ i: 'block-second-0', x: 0, y: 1, w: 1, h: 8, static: true },
		{ i: 'block-second-1', x: 1.2, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-2', x: 3.6, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-3', x: 6, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-4', x: 8.4, y: 1, w: 2, h: 8, static: true },
		{ i: 'block-second-5', x: 10.8, y: 1, w: 1, h: 8, static: true },

		{ i: 'block-third-0', x: 0, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-1', x: 2.4, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-2', x: 4.8, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-3', x: 7.2, y: 9, w: 2.4, h: 8, static: true },
		{ i: 'block-third-4', x: 9.6, y: 9, w: 1.4, h: 8, static: true },

		{ i: 'block-fourth-0', x: 0, y: 17, w: 1, h: 8, static: true },
		{ i: 'block-fourth-1', x: 1.2, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-2', x: 3.6, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-3', x: 6, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-4', x: 8.4, y: 17, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-5', x: 10.8, y: 17, w: 1.2, h: 8, static: true },

		{ i: 'block-fifth-0', x: 0, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-1', x: 2.4, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-2', x: 4.8, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-3', x: 7.2, y: 25, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-4', x: 9.6, y: 25, w: 1.4, h: 8, static: true },

		{ i: 'block-sixth-0', x: 0, y: 33, w: 1.2, h: 8, static: true },
		{ i: 'block-sixth-1', x: 1.2, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-2', x: 3.6, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-3', x: 6, y: 33, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-4', x: 8.4, y: 33, w: 2.3, h: 8, static: true },
		{ i: 'block-sixth-5', x: 10.9, y: 33, w: 1.3, h: 8, static: true },

		{ i: 'block-seventh-0', x: 0, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-1', x: 2.4, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-2', x: 4.8, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-3', x: 7.2, y: 41, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-4', x: 9.6, y: 41, w: 1.4, h: 8, static: true },

		{ i: 'block-eighth-0', x: 0, y: 49, w: 1, h: 8, static: true },
		{ i: 'block-eighth-1', x: 1.2, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-2', x: 3.6, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-3', x: 6, y: 49, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-4', x: 8.4, y: 49, w: 1.4, h: 8, static: true },
	],
};

export const HOME_LAYOUT_GRID_MOVEABLE = {
	xs: [
		{ i: 'block-top-0', x: 0, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-1', x: 2.4, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-2', x: 4.8, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-3', x: 7.2, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-4', x: 9.6, y: -15, w: 2, h: 1, static: true },

		{ i: 'block-second-0', x: 0, y: -3, w: 1, h: 8, static: true },
		{ i: 'block-second-1', x: 1.2, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-2', x: 3.6, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-3', x: 6, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-4', x: 8.4, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-5', x: 10.8, y: -3, w: 1, h: 8, static: true },

		{ i: 'block-third-0', x: 0, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-1', x: 2.4, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-2', x: 4.8, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-3', x: 7.2, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-4', x: 9.6, y: 5, w: 1.4, h: 8, static: true },

		{ i: 'block-fourth-0', x: 0, y: 13, w: 1, h: 8, static: true },
		{ i: 'block-fourth-1', x: 1.2, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-2', x: 3.6, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-3', x: 6, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-4', x: 8.4, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-5', x: 10.8, y: 13, w: 1.2, h: 8, static: true },

		{ i: 'block-fifth-0', x: 0, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-1', x: 2.4, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-2', x: 4.8, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-3', x: 7.2, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-4', x: 9.6, y: 21, w: 1.4, h: 8, static: true },

		{ i: 'block-sixth-0', x: 0, y: 29, w: 1.2, h: 8, static: true },
		{ i: 'block-sixth-1', x: 1.2, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-2', x: 3.6, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-3', x: 6, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-4', x: 8.4, y: 29, w: 2.3, h: 8, static: true },
		{ i: 'block-sixth-5', x: 10.9, y: 29, w: 1.3, h: 8, static: true },

		{ i: 'block-seventh-0', x: 0, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-1', x: 2.4, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-2', x: 4.8, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-3', x: 7.2, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-4', x: 9.6, y: 37, w: 1.4, h: 8, static: true },

		{ i: 'block-eighth-0', x: 0, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-1', x: 1.2, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-2', x: 3.6, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-3', x: 6, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-4', x: 8.4, y: 45, w: 1.4, h: 8, static: true },
	],
	sm: [
		{ i: 'block-top-0', x: 0, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-1', x: 2.4, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-2', x: 4.8, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-3', x: 7.2, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-4', x: 9.6, y: -15, w: 2, h: 1, static: true },

		{ i: 'block-second-0', x: 0, y: -3, w: 1, h: 8, static: true },
		{ i: 'block-second-1', x: 1.2, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-2', x: 3.6, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-3', x: 6, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-4', x: 8.4, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-5', x: 10.8, y: -3, w: 1, h: 8, static: true },

		{ i: 'block-third-0', x: 0, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-1', x: 2.4, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-2', x: 4.8, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-3', x: 7.2, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-4', x: 9.6, y: 5, w: 1.4, h: 8, static: true },

		{ i: 'block-fourth-0', x: 0, y: 13, w: 1, h: 8, static: true },
		{ i: 'block-fourth-1', x: 1.2, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-2', x: 3.6, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-3', x: 6, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-4', x: 8.4, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-5', x: 10.8, y: 13, w: 1.2, h: 8, static: true },

		{ i: 'block-fifth-0', x: 0, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-1', x: 2.4, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-2', x: 4.8, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-3', x: 7.2, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-4', x: 9.6, y: 21, w: 1.4, h: 8, static: true },

		{ i: 'block-sixth-0', x: 0, y: 29, w: 1.2, h: 8, static: true },
		{ i: 'block-sixth-1', x: 1.2, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-2', x: 3.6, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-3', x: 6, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-4', x: 8.4, y: 29, w: 2.3, h: 8, static: true },
		{ i: 'block-sixth-5', x: 10.9, y: 29, w: 1.3, h: 8, static: true },

		{ i: 'block-seventh-0', x: 0, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-1', x: 2.4, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-2', x: 4.8, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-3', x: 7.2, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-4', x: 9.6, y: 37, w: 1.4, h: 8, static: true },

		{ i: 'block-eighth-0', x: 0, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-1', x: 1.2, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-2', x: 3.6, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-3', x: 6, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-4', x: 8.4, y: 45, w: 1.4, h: 8, static: true },
	],
	md: [
		{ i: 'block-top-0', x: 0, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-1', x: 2.4, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-2', x: 4.8, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-3', x: 7.2, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-4', x: 9.6, y: -15, w: 2, h: 1, static: true },

		{ i: 'block-second-0', x: 0, y: -3, w: 1, h: 8, static: true },
		{ i: 'block-second-1', x: 1.2, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-2', x: 3.6, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-3', x: 6, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-4', x: 8.4, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-5', x: 10.8, y: -3, w: 1, h: 8, static: true },

		{ i: 'block-third-0', x: 0, y: 5, w: 2.4, h: 8, static: false },
		{ i: 'block-third-1', x: 2.4, y: 5, w: 2.4, h: 8, static: false },
		{ i: 'block-third-2', x: 4.8, y: 5, w: 2.4, h: 8, static: false },
		{ i: 'block-third-3', x: 7.2, y: 5, w: 2.4, h: 8, static: false },
		{ i: 'block-third-4', x: 9.6, y: 5, w: 2.4, h: 8, static: false },

		{ i: 'block-fourth-0', x: 0, y: 13, w: 1, h: 8, static: true },
		{ i: 'block-fourth-1', x: 1.2, y: 13, w: 2.3, h: 8, static: true },
		{ i: 'block-fourth-2', x: 3.6, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-3', x: 6, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-4', x: 8.4, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-5', x: 10.8, y: 13, w: 1.2, h: 8, static: true },

		{ i: 'block-fifth-0', x: 0, y: 21, w: 2.4, h: 8, static: false },
		{ i: 'block-fifth-1', x: 2.4, y: 21, w: 2.4, h: 8, static: false },
		{ i: 'block-fifth-2', x: 4.8, y: 21, w: 2.4, h: 8, static: false },
		{ i: 'block-fifth-3', x: 7.2, y: 21, w: 2.4, h: 8, static: false },
		{ i: 'block-fifth-4', x: 9.6, y: 21, w: 2.4, h: 8, static: false },

		{ i: 'block-sixth-0', x: 0, y: 29, w: 1, h: 8, static: true },
		{ i: 'block-sixth-1', x: 1.2, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-2', x: 3.6, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-3', x: 6, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-4', x: 8.4, y: 29, w: 2.3, h: 8, static: true },
		{ i: 'block-sixth-5', x: 10.9, y: 29, w: 1.3, h: 8, static: true },

		{ i: 'block-seventh-0', x: 0, y: 37, w: 2.4, h: 8, static: false },
		{ i: 'block-seventh-1', x: 2.4, y: 37, w: 2.4, h: 8, static: false },
		{ i: 'block-seventh-2', x: 4.8, y: 37, w: 2.4, h: 8, static: false },
		{ i: 'block-seventh-3', x: 7.2, y: 37, w: 2.4, h: 8, static: false },
		{ i: 'block-seventh-4', x: 9.6, y: 37, w: 1.4, h: 8, static: false },

		{ i: 'block-eighth-0', x: 0, y: 45, w: 1, h: 8, static: true },
		{ i: 'block-eighth-1', x: 1.2, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-2', x: 3.6, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-3', x: 6, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-4', x: 8.4, y: 45, w: 1.4, h: 8, static: true },
	],
	lg: [
		{ i: 'block-top-0', x: 0, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-1', x: 2.4, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-2', x: 4.8, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-3', x: 7.2, y: -15, w: 2, h: 1, static: true },
		{ i: 'block-top-4', x: 9.6, y: -15, w: 2, h: 1, static: true },

		{ i: 'block-second-0', x: 0, y: -3, w: 1, h: 8, static: true },
		{ i: 'block-second-1', x: 1.2, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-2', x: 3.6, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-3', x: 6, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-4', x: 8.4, y: -3, w: 2, h: 8, static: true },
		{ i: 'block-second-5', x: 10.8, y: -3, w: 1, h: 8, static: true },

		{ i: 'block-third-0', x: 0, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-1', x: 2.4, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-2', x: 4.8, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-3', x: 7.2, y: 5, w: 2.4, h: 8, static: true },
		{ i: 'block-third-4', x: 9.6, y: 5, w: 1.4, h: 8, static: true },

		{ i: 'block-fourth-0', x: 0, y: 13, w: 1, h: 8, static: true },
		{ i: 'block-fourth-1', x: 1.2, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-2', x: 3.6, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-3', x: 6, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-4', x: 8.4, y: 13, w: 2.4, h: 8, static: true },
		{ i: 'block-fourth-5', x: 10.8, y: 13, w: 1.2, h: 8, static: true },

		{ i: 'block-fifth-0', x: 0, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-1', x: 2.4, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-2', x: 4.8, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-3', x: 7.2, y: 21, w: 2.4, h: 8, static: true },
		{ i: 'block-fifth-4', x: 9.6, y: 21, w: 1.4, h: 8, static: true },

		{ i: 'block-sixth-0', x: 0, y: 29, w: 1.2, h: 8, static: true },
		{ i: 'block-sixth-1', x: 1.2, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-2', x: 3.6, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-3', x: 6, y: 29, w: 2.4, h: 8, static: true },
		{ i: 'block-sixth-4', x: 8.4, y: 29, w: 2.3, h: 8, static: true },
		{ i: 'block-sixth-5', x: 10.9, y: 29, w: 1.3, h: 8, static: true },

		{ i: 'block-seventh-0', x: 0, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-1', x: 2.4, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-2', x: 4.8, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-3', x: 7.2, y: 37, w: 2.4, h: 8, static: true },
		{ i: 'block-seventh-4', x: 9.6, y: 37, w: 1.4, h: 8, static: true },

		{ i: 'block-eighth-0', x: 0, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-1', x: 1.2, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-2', x: 3.6, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-3', x: 6, y: 45, w: 2.4, h: 8, static: true },
		{ i: 'block-eighth-4', x: 8.4, y: 45, w: 1.4, h: 8, static: true },
	],
};
